module.exports = __webpack_public_path__ + "./Ning_color_7f5f495de611e00f4c49707518b3b4b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2023/Ning_color.jpg
// module id = 604
// module chunks = 0